import user from '../modules/user/types/action-types';
import viewContent from '../modules/viewContent/types/action-types';
import editor from '../modules/editor/types/action-types';
import subHeader from '../modules/subHeader/types/action-types';
import mandantEditor from '../modules/mandantEditor/types/action-types';
import sharedEditor from '../modules/sharedEditor/types/action-types';
import aufgaben from '../modules/aufgaben/types/action-types';
import mandanten from '../modules/mandanten/types/action-types';
import shopAdmin from '../modules/shopAdmin/types/action-types';
import shopClient from '../modules/shopClient/types/action-types';
import shopInfo from '../modules/shopInfo/types/action-types';

const TYPES = {
  user,
  viewContent,
  subHeader,
  editor,
  mandantEditor,
  sharedEditor,
  aufgaben,
  mandanten,
  shopAdmin,
  shopClient,
  shopInfo,
};

export default TYPES;
